import { useEffect } from 'react';
import { MapCenterNavigation } from '../../../../core/types/types';
import { useMap } from 'react-leaflet';

export const AnimationControl = ({ mapCenterCoords, zoom }: MapCenterNavigation) => {
    const map = useMap();
    useEffect(() => {
        map.flyTo([mapCenterCoords.lat, mapCenterCoords.lng], zoom);
    }, [mapCenterCoords, zoom]);
    return null;
};
// if (typeof mapCenterCoords.lat === 'number' && typeof mapCenterCoords.lng === 'number') {
// if (zoom < 19)
// else map.flyTo([mapCenterCoords.lat, mapCenterCoords.lng], 18);
// }
